import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../../components/Button/Button";
import TextInput from "../../../components/TextInput/TextInput";
/**Firebase Imports**/
import { db, collection, addDoc } from "../../../firebaseConfig";

export default function AdminAddLinkScreen() {
	const navigate = useNavigate();
	const [isProcessing, setIsProcessing] = useState(false);

	const [headline, setHeadline] = useState({
		value: "",
		error: "",
	});
	const [description, setDescription] = useState({
		value: "",
		error: "",
	});
	const [URL, setURL] = useState({
		value: "",
		error: "",
	});

	/**
	 * Main Functions
	 */
	const handleAddLink = async () => {
		setIsProcessing(true);
		if (checkErrors()) {
			// eslint-disable-next-line no-unused-vars
			const docRef = await addDoc(collection(db, "links"), {
				heading: headline.value,
				URL: URL.value,
				description: description.value,
			});
			setIsProcessing(false);
			navigate("/admin/landing");
		}
		setIsProcessing(false);
	};
	/****/

	/**
	 * Utility Functions
	 */
	function checkErrors() {
		var noErrors = true;
		if (headline.value === "") {
			setHeadline({ value: "", error: "*Headline cannot be empty" });
			noErrors = false;
		}
		if (description.value === "") {
			setDescription({ value: "", error: "*Desciption cannot be empty" });
			noErrors = false;
		}
		if (URL.value === "") {
			setURL({ value: "", error: "*URL cannot be empty" });
			noErrors = false;
		}
		return noErrors;
	}
	return (
		<div className="AdminAddLinkScreen h-full w-full flex flex-col justify-between">
			<div className="p-6 justify-between px-6 pb-8 flex flex-col items-center">
				<p className="font-bold text-left my-8 mr-auto">Link</p>
				<TextInput
					placeholder={"Headline"}
					className={"shadow-none h-10"}
					type={"text"}
					name={"headline"}
					id={"headline"}
					value={headline.value}
					onChange={(e) => {
						setHeadline({ value: e.target.value, error: "" });
					}}
					error={headline.error !== ""}
					errorMessage={headline.error}
				/>
				<TextInput
					placeholder={"Description"}
					className={"mt-6 shadow-none h-10"}
					type={"text"}
					name={"description"}
					id={"description"}
					value={description.value}
					onChange={(e) => {
						setDescription({ value: e.target.value, error: "" });
					}}
					error={description.error !== ""}
					errorMessage={description.error}
				/>
				<TextInput
					placeholder={"Website URL"}
					className={"mt-6 shadow-none h-10"}
					type={"text"}
					name={"url"}
					id={"url"}
					value={URL.value}
					onChange={(e) => {
						setURL({ value: e.target.value, error: "" });
					}}
					error={URL.error !== ""}
					errorMessage={URL.error}
				/>
			</div>

			<div className="w-full flex flex-row justify-between px-6 pb-8">
				<Button
					mode={"outlined"}
					size={"lg-2"}
					title={isProcessing ? "o o o" : "CANCEL"}
					disabled={isProcessing}
					className={"mt-7 text-red-500"}
					onClick={() => navigate("/admin/landing")}
				/>
				<Button
					mode={"outlined"}
					size={"lg-2"}
					title={isProcessing ? "o o o" : "SAVE CHANGES"}
					disabled={isProcessing}
					className={"mt-7 text-green-500"}
					onClick={() => handleAddLink()}
				/>
			</div>
		</div>
	);
}
